import { ShieldCheck, UserCog } from 'lucide-react';
/**
 * The pages of the own profile by name only - what the navigation and the command palette need
 * on every page. The pages themselves (`profile-areas.tsx`) load with the profile.
 */
/**
 * The areas of the own profile (after Corly): who I am, and how I get in - each a page, the
 * same in every app; an app adds its own groups. Light or dark is chosen in the account menu.
 */
export const PROFILE_GROUPS = [
    {
        key: 'account',
        title: 'Konto',
        areas: [
            {
                slug: 'personal',
                title: 'Persönliche Daten',
                description: 'Ihr Name, wie Kanos Sie nennt.',
                icon: UserCog,
            },
            {
                slug: 'security',
                title: 'Anmeldung & Sicherheit',
                description: 'Passkeys, Passwort, E-Mail-Adresse, Zwei-Faktor und Ihre Geräte.',
                icon: ShieldCheck,
            },
        ],
    },
];
/**
 * The tabs of „Anmeldung & Sicherheit“ (after Corly): the overview, one tab per way in - the
 * passkeys, the password, the address, the second factor - and the devices.
 */
export const SECURITY_TABS = [
    { slug: '', title: 'Übersicht' },
    { slug: 'passkeys', title: 'Passkeys' },
    { slug: 'password', title: 'Passwort' },
    { slug: 'email', title: 'E-Mail' },
    { slug: 'two-factor', title: 'Zwei-Faktor' },
    { slug: 'devices', title: 'Geräte' },
];
/** Whether a path below the profile is one of its pages: an area, or a tab of the security. */
export function profilePageOf(rest) {
    const [area = '', tab = '', more] = rest.split('/');
    if (more !== undefined)
        return null;
    if (area === 'personal' && tab === '')
        return { area, tab };
    if (area === 'security' && SECURITY_TABS.some((t) => t.slug === tab))
        return { area, tab };
    return null;
}
/** The profile's places for the command palette; `go` leads to a path below `/profile`. */
export function profileCommands(go) {
    return [
        ...PROFILE_GROUPS.flatMap((group) => group.areas.map((area) => ({
            id: `/profile/${area.slug}`,
            label: area.title,
            group: 'Profil',
            keywords: area.description,
            icon: area.icon,
            onAction: go(`/profile/${area.slug}`),
        }))),
        ...SECURITY_TABS.filter((tab) => tab.slug !== '').map((tab) => ({
            id: `/profile/security/${tab.slug}`,
            label: tab.title,
            group: 'Profil',
            keywords: 'Anmeldung Sicherheit',
            onAction: go(`/profile/security/${tab.slug}`),
        })),
    ];
}
//# sourceMappingURL=profile-pages.js.map